

export default {
  methods: {
    confirmarAcao(title, text, confirmButtonText, cancelButtonText, callbackFn) {
      this.showConfirmDialog({
        title,
        text,
        width: '35em',
        confirmButtonText,
        cancelButtonText,
      }).then((data) => {
        if (data.value) {
          callbackFn();
        }
      });
    },
    exibirOkDialog(title, text) {
      this.showOkDialog({
        title,
        text,
        confirmButtonText: 'OK',
        width: '35em',
      });
    },
    callService(requestService, event, messages = {}) {
      const loader = this.$loading.show();
      requestService
        .then(() => {
          this.exibirOkDialog(messages.successTitle, messages.successMessage);
        })
        .catch(() => {
          this.exibirOkDialog(messages.errorTitle, messages.errorMessage);
        })
        .finally(() => {
          this.$root.$emit(event, {});
          loader.hide();
        });
    },
  },
};
